import React from "react";
import { Award, UserCheck, Leaf } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheAnvStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const features = [{
    title: "20+ Years Experience",
    description: "Leveraging over two decades of industry expertise to deliver flawless finishes and reliable project management for every client.",
    icon: <Award className="size-10 text-primary" />,
    badge: null
  }, {
    title: "Personalized Service",
    description: "We combine professional project management with a personal touch, ensuring your specific vision and timelines are met with precision.",
    icon: <UserCheck className="size-10 text-primary" />,
    badge: null
  }, {
    title: "Eco-Conscious Paints",
    description: "Prioritizing your health and the environment by using premium, sustainable products that ensure vibrant, lasting results.",
    icon: <Leaf className="size-10 text-primary" />,
    badge: "Low-VOC"
  }];
  return <section id="the-anv-standard" className="dark bg-background text-foreground py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559587/img/anv_logo_watermark.png" alt="" className="w-[80%] max-w-4xl opacity-[0.03] grayscale invert-0" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {features.map((feature, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center space-y-6 group">
              <div className="p-4 rounded-full bg-accent/10 border border-white/5 shadow-2xl backdrop-blur-sm group-hover:bg-accent/20 transition-colors duration-300">
                {feature.icon}
              </div>
              
              <div className="space-y-3">
                <h3 className="text-2xl font-semibold tracking-tight text-white">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed max-w-xs mx-auto">
                  {feature.description}
                </p>
              </div>

              {feature.badge && <Badge variant="default" className="bg-[var(--chart-2)] hover:bg-[var(--chart-2)]/90 text-white border-none px-3 py-1 text-xs tracking-wide uppercase font-bold shadow-lg shadow-[var(--chart-2)]/20">
                  {feature.badge}
                </Badge>}
            </div>)}
        </div>
      </div>
    </section>;
}